import { LanguageLocaleEnum, patchUser } from "@/api/openapi";
import { PspContext } from "@/config/contexts";
import { translate } from "@/config/translator";
import { useContext } from "react";
import { LanguageSelectorProps } from "./LanguageSelector.types";
import PspSelect from "../pspSelect/pspSelect";

export default function LanguageSelector({ me }: LanguageSelectorProps) {
  // -----------------------------------------------------------------------------
  // GENERAL
  // -----------------------------------------------------------------------------
  const { lang, setLang } = useContext(PspContext);

  // -----------------------------------------------------------------------------
  // EVENT HANDLERS
  // -----------------------------------------------------------------------------
  function onChangeLanguage(value: string) {
    if (me) {
      patchUser({
        body: {
          language: value as LanguageLocaleEnum,
        },
      });
    }
    setLang(value as LanguageLocaleEnum);
  }

  return (
    <div className="inline-block h-fit w-fit">
      <PspSelect label="language" value={lang} onChange={onChangeLanguage}>
        <option value="de">{translate("german", lang)}</option>
        <option value={"it"}>{translate("italian", lang)}</option>
        <option value={"en"}>{translate("english", lang)}</option>
      </PspSelect>
    </div>
  );
}
